import { memo } from 'react'
import { extensionOf, extensionTone } from './mediaLibraryFormat.js'
import './MediaExtBadge.css'

/** Pastille de format (MP4, MOV, MXF…), teintée par famille. */
export const MediaExtBadge = memo(function MediaExtBadge({ name, size = 'md' }: { name: string; size?: 'sm' | 'md' }) {
  const ext = extensionOf(name)
  return (
    <span className={`media-ext media-ext--${extensionTone(ext)} media-ext--${size}`} aria-hidden>
      {ext || '—'}
    </span>
  )
})
